import { SidebarLeft } from "@/components/layouts/sidebar-left";
import { SidebarRight } from "@/components/layouts/sidebar-right";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import InsetHeader from "./header";
import { PageHeader } from "./page-header/index.tsx";
import { SkeletonContent } from "../shared/skeleton-content/index.tsx";

export interface MainLayoutProps {
  children: React.ReactNode;
  rightSidebar?: boolean;
  breadcrumb?: { name: string; href: string }[];
  nopad?: boolean;
  pageHeader?: {
    title: string;
    subtitle: string;
    buttonText?: string;
    onButtonClick?: () => void;
    buttonDisabled?: boolean;
    additionalButtons?: React.ReactNode;
  };
  loading?: boolean;
}

export default function MainLayout({
  children,
  rightSidebar = false,
  breadcrumb,
  nopad = false,
  pageHeader,
  loading,
}: MainLayoutProps) {
  return (
    <SidebarProvider>
      <SidebarLeft />
      <SidebarInset>
        <InsetHeader rightSidebar={rightSidebar} breadcrumb={breadcrumb} />
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col gap-2">
            <div className={`"flex flex-col gap-4 ${nopad ? "p-0" : "py-4 md:gap-6 md:py-6 px-4 lg:px-6"}`}>
              {!!pageHeader && <PageHeader {...pageHeader} />}
              {loading ? <SkeletonContent /> : children}
            </div>
          </div>
        </div>
      </SidebarInset>
      {rightSidebar && <SidebarRight />}
    </SidebarProvider>
  );
}
